export function branchWhatsAppUrl(
  phone: string | undefined,
  branchName: string | undefined,
): string | undefined {
  const digits = phone?.replace(/\D/gu, "");
  if (!digits) return undefined;
  const message = `Halo ${branchName || "Warung Sedap Sayur"}, saya ingin bertanya tentang produk di cabang ini.`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}
